import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';

@Injectable()
export class AdminSettingsCatalogueProvider {

    constructor(private http: HttpClient) {}

    update(campId: number, params: any): Observable<any> {
        return this.http.put(`${environment.envVar.API_URL}/camp/${campId}/settings/catalogue`, params).pipe(
            map(data => data)
        );
    }
}
